import { action } from 'sky-engine/api/index'

import { FEATURE_MNG, POC_MNG_SCENE_RESEARCH } from '@/api/apiModules'
/**
 * 获取行业与场景规格数据
 * @param {*} data
 * @returns
 */
export function getIndustryScene(data) {
  return action(POC_MNG_SCENE_RESEARCH, 'getIndustryScene', data)
}
/**
 *  获取业务调研步骤实例数据，包括：行业，场景，功能
 * @param {*} data
 * @returns
 */
export function getBusinessResearch(data) {
  return action(POC_MNG_SCENE_RESEARCH, 'getBusinessResearch', data)
}
/**
 * 保存表单数据
 * @param {*} data
 * @returns
 */

export function saveBusinessResearch(data) {
  return action(POC_MNG_SCENE_RESEARCH, 'saveBusinessResearch', data)
}

/**
 * 业务调研，实例数据保存
 * @param {*} data
 * @returns
 */

export function saveSceneResearch(data) {
  return action(POC_MNG_SCENE_RESEARCH, 'saveSceneResearch', data)
}
/**
 * 业务调研，实例数据保存
 * @param {*} data
 * @returns
 */

export function getSceneResearch(data) {
  return action(POC_MNG_SCENE_RESEARCH, 'getSceneResearch', data)
}

/**
 * 根据场景获取功能规格数据
 * @param {*} data
 * @returns
 */

export function listSpecFeature(data) {
  return action(FEATURE_MNG, 'listSceneFeature', data)
}

/**
 * 根据场景ID 比对功能
 * @param {*} data
 * @returns
 */
export function matchSceneListSpecFeature(data) {
  return action(FEATURE_MNG, 'scene/listSceneFeature', data)
}

/**
 * 功能规格详情
 * @param {*} data
 * @returns
 */

export function getSpecFeatureInfo(data) {
  return action(FEATURE_MNG, 'info', data)
}

/**
 * 功能规格详情
 * @param {*} data
 * @returns
 */
export function getFeatureByProductAndName(data) {
  return action(FEATURE_MNG, 'getFeatureByProductAndName', data)
}

/**
 * 功能规格详情
 * @param {*} data
 * @returns
 */

export function getSpecFeatureList(data) {
  return action(FEATURE_MNG, 'list', data)
}
